module.exports = __webpack_public_path__ + "static/media/brand-icons.a1a749e8.svg";